import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  formatOrderStatusClassName,
  formatOrderStatusLabel,
  formatOrderStatusDescription,
} from '../../utils/format';

const OrderStatus = ({ status, showDescription }) => {
  return (
    <React.Fragment>
      <div className={cn('entry-status', formatOrderStatusClassName(status))}>
        <span
          className={cn(
            'entry-status__badge badge badge--dot',
            formatOrderStatusClassName(status, 'badge--')
          )}
        />
        <span
          className={cn(
            'entry-status__label',
            formatOrderStatusClassName(status, 'color--')
          )}
        >
          {formatOrderStatusLabel(status)}
        </span>
      </div>
      {showDescription && (
        <div className="entry-tip">{formatOrderStatusDescription(status)}</div>
      )}
    </React.Fragment>
  );
};

OrderStatus.defaultProps = {
  status: null,
  showDescription: false,
};
OrderStatus.propTypes = {
  status: PropTypes.string,
  showDescription: PropTypes.bool,
};

export default OrderStatus;
